const getInitialState = () => ({
  transactionList: [],
  tableFields: [
    { displayName: 'ID', fieldName: 'pk', linked: true },
    {
      displayName: 'Name (preferred name)',
      fieldName: 'name',
      linked: false,
      orderField: 'customerFirstName',
    },
    {
      displayName: 'Membership ID',
      fieldName: 'membershipId',
      orderField: 'membershipId',
    },
    {
      displayName: 'Creation Date',
      fieldName: 'displayCreationDate',
      orderField: 'creationDate',
    },
    {
      displayName: 'Total Amount',
      fieldName: 'totalRewardAmount',
      orderField: 'totalRewardAmount',
    },
    { displayName: 'Transaction Type', fieldName: 'transactionDisplayType' },
    { displayName: 'Status', fieldName: 'displayOfflineEventType' },
    { displayName: 'Approved By', fieldName: 'approvedBy' },
    { displayName: 'AI Detection Status', fieldName: 'aiStatus' },
    { displayName: 'Spot Check Status', fieldName: 'spotCheckStatus' },
  ],
  pageInfo: {
    startCursor: '',
    endCursor: '',
    hasNextPage: false,
    hasPreviousPage: false,
  },
  currentPage: 0,
  totalPage: 0,
  totalCount: 0,
  checkedList: [],
});

export default {
  namespace: 'spotCheckTransactions',
  state: getInitialState(),

  reducers: {
    clearData(state, { payload }) {
      return {
        ...state,
        ...getInitialState(),
      };
    },

    updateState(state, { payload }) {
      return { ...state, ...payload };
    },
  },
};
